module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-beginners@2x.0888b7ee.png";